import { render, staticRenderFns } from "./transits.vue?vue&type=template&id=fb568efc&"
import script from "./transits.vue?vue&type=script&lang=js&"
export * from "./transits.vue?vue&type=script&lang=js&"
import style0 from "./transits.vue?vue&type=style&index=0&id=fb568efc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports